// Unified analytics helper — fires events for Google Ads + Meta Pixel.
// Safe to call before tags load — silently no-ops if globals aren't ready.

const GOOGLE_LEAD = {
  send_to: "AW-18135825205/7622625753",
  value: 1.0,
  currency: "USD",
};

function _gtag(...args) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    window.gtag(...args);
  } catch (_) { /* no-op */ }
}

function _fbq(...args) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.fbq !== "function") return;
    window.fbq(...args);
  } catch (_) { /* no-op */ }
}

/** Fire conversion + Meta Lead event after a contact form submission. */
export function trackLeadConversion(extra = {}) {
  _gtag("event", "conversion", { ...GOOGLE_LEAD, ...extra });
  _fbq("track", "Lead", {
    content_name: extra.service || "Contact Form",
    content_category: extra.event_source || "contact_form",
    value: 1.0,
    currency: "USD",
  });
}

/** Fire conversion + Meta Schedule event after a booking submission. */
export function trackBookingConversion(extra = {}) {
  _gtag("event", "conversion", { ...GOOGLE_LEAD, ...extra });
  _fbq("track", "Schedule", {
    content_name: extra.service || "Appointment",
    content_category: "booking",
    value: 1.0,
    currency: "USD",
  });
}

/** Fire a generic event to both platforms. */
export function trackEvent(name, params = {}) {
  _gtag("event", name, params);
  _fbq("trackCustom", name, params);
}
